import { Box, Flex } from '@chakra-ui/react';
import { CardPalette, Team } from '../HistoryCard.types';
import { TeamDisplay } from './TeamDisplay';

interface MatchDisplayProps {
  teamA: Team;
  teamB: Team;
  palette: CardPalette;
}

export const MatchDisplay = ({ teamA, teamB, palette }: MatchDisplayProps) => (
  <Box
    bgGradient={palette.gradientBg}
    borderRadius={{ base: 'lg', md: 'xl' }}
    p={{ base: 3, md: 5 }}
    boxShadow='inner'
    border='1px solid'
    borderColor='dark.D100'
  >
    <Flex
      justify='center'
      align='flex-start'
      gap={{ base: 3, sm: 4, md: 6 }}
      flexWrap='wrap'
      dir='ltr'
    >
      <TeamDisplay team={teamA} accentColor={palette.accentColor} />
      <Box
        bg={palette.accentColor}
        color='white'
        px={{ base: 2, md: 3 }}
        py={{ base: 0.5, md: 1.5 }}
        borderRadius={{ base: 'md', md: 'lg' }}
        fontWeight='bold'
        fontSize={{ base: 'xs', md: 'md' }}
        boxShadow='sm'
        flexShrink={0}
        alignSelf='center'
      >
        VS
      </Box>
      <TeamDisplay team={teamB} accentColor={palette.accentColor} />
    </Flex>
  </Box>
);
